export const contentCreation = {
  "university": "University of Hull",
  "platform_analysis": {
    "social_media": [
      {
        "platform": "Social Media",
        "sub_platform": "Facebook",
        "current_status": "Limited Engagement",
        "specific_issue": "Profile needs improvement - missing key program information and student testimonials",
        "improvement_needed": "Update profile with program highlights, add student success stories, and increase post frequency",
        "priority": "High",
        "estimated_impact": "Increase engagement by 40-60%",
        "ready_to_generate": true
      },
      {
        "platform": "Social Media",
        "sub_platform": "LinkedIn",
        "current_status": "Good Foundation",
        "specific_issue": "Company page needs more thought leadership content and industry connections",
        "improvement_needed": "Share research insights, connect with industry leaders, and post regular updates",
        "priority": "Medium",
        "estimated_impact": "Improve professional reputation by 25-35%",
        "ready_to_generate": true
      },
      {
        "platform": "Social Media",
        "sub_platform": "Instagram",
        "current_status": "Basic Presence",
        "specific_issue": "Missing visual storytelling and student life content",
        "improvement_needed": "Create campus life stories, showcase facilities, and add student testimonials",
        "priority": "High",
        "estimated_impact": "Increase student interest by 50-70%",
        "ready_to_generate": true
      },
      {
        "platform": "Social Media",
        "sub_platform": "Twitter",
        "current_status": "Underutilized",
        "specific_issue": "Limited engagement and inconsistent posting schedule",
        "improvement_needed": "Establish daily posting schedule, engage with industry conversations, and share research highlights",
        "priority": "Medium",
        "estimated_impact": "Improve brand visibility by 30-45%",
        "ready_to_generate": true
      }
    ],
    "website": [
      {
        "platform": "Website",
        "sub_platform": "Homepage",
        "current_status": "Functional but Generic",
        "specific_issue": "Missing compelling value proposition and clear call-to-action",
        "improvement_needed": "Add hero section with program benefits, student testimonials, and clear application CTA",
        "priority": "High",
        "estimated_impact": "Increase conversion rate by 30-45%",
        "ready_to_generate": true
      },
      {
        "platform": "Website",
        "sub_platform": "Program Pages",
        "current_status": "Basic Information",
        "specific_issue": "Lacks detailed curriculum, career outcomes, and student experiences",
        "improvement_needed": "Add detailed module descriptions, alumni success stories, and career statistics",
        "priority": "High",
        "estimated_impact": "Improve student decision-making by 40-55%",
        "ready_to_generate": true
      },
      {
        "platform": "Website",
        "sub_platform": "Faculty Profiles",
        "current_status": "Minimal Content",
        "specific_issue": "Basic faculty information without research highlights and expertise",
        "improvement_needed": "Add research publications, industry experience, and student testimonials",
        "priority": "Medium",
        "estimated_impact": "Build credibility by 25-35%",
        "ready_to_generate": true
      }
    ],
    "digital_content": [
      {
        "platform": "Digital Content",
        "sub_platform": "Blog Posts",
        "current_status": "Inconsistent",
        "specific_issue": "Irregular posting schedule and generic content",
        "improvement_needed": "Establish weekly posting schedule, create industry-relevant content, and add expert insights",
        "priority": "Medium",
        "estimated_impact": "Increase website traffic by 35-50%",
        "ready_to_generate": true
      },
      {
        "platform": "Digital Content",
        "sub_platform": "Video Content",
        "current_status": "Limited",
        "specific_issue": "Missing program overviews and faculty insights",
        "improvement_needed": "Create program introduction videos, faculty interviews, and campus tours",
        "priority": "High",
        "estimated_impact": "Improve program visibility by 60-80%",
        "ready_to_generate": true
      },
      {
        "platform": "Digital Content",
        "sub_platform": "Infographics",
        "current_status": "None",
        "specific_issue": "No visual content to explain complex concepts",
        "improvement_needed": "Create program structure infographics, career outcome charts, and student journey maps",
        "priority": "Medium",
        "estimated_impact": "Improve content engagement by 40-60%",
        "ready_to_generate": true
      }
    ],
    "thought_leadership": [
      {
        "platform": "Thought Leadership",
        "sub_platform": "Research Papers",
        "current_status": "Strong Academic",
        "specific_issue": "Limited public accessibility and industry application focus",
        "improvement_needed": "Create executive summaries, industry applications, and public-facing research highlights",
        "priority": "Medium",
        "estimated_impact": "Improve industry recognition by 25-40%",
        "ready_to_generate": true
      },
      {
        "platform": "Thought Leadership",
        "sub_platform": "Industry Reports",
        "current_status": "Basic",
        "specific_issue": "Limited industry-focused research and insights",
        "improvement_needed": "Develop industry-specific research reports, market analysis, and trend insights",
        "priority": "Medium",
        "estimated_impact": "Establish industry authority by 30-45%",
        "ready_to_generate": true
      }
    ]
  },
  "content_recommendations": [
    {
      "content_type": "Social Media - Facebook",
      "piece_type": "social_post",
      "title": "Facebook Content Strategy for University of Hull MBA Program",
      "keywords": ["facebook", "mba", "university", "higher education", "social media", "engagement", "community"],
      "primary_citation": {
        "source": "University of Hull Facebook Analysis",
        "url": "https://www.hull.ac.uk",
        "title": "Facebook Content Strategy",
        "snippet": "Analysis of Facebook content needs for University of Hull",
        "confidence": 0.9,
        "type": "platform_analysis",
        "domain": "social_media"
      },
      "secondary_citation": {
        "source": "Social Media Best Practices",
        "url": "https://socialmediabest-practices.com",
        "title": "Facebook Content Guidelines",
        "snippet": "Industry best practices for Facebook content in MBA programs",
        "confidence": 0.85,
        "type": "industry_guidelines",
        "domain": "social_media"
      },
      "impact_score": 85.0,
      "estimated_effort": "1-2 weeks"
    },
    {
      "content_type": "Website - Homepage",
      "piece_type": "webpage",
      "title": "Homepage Content Strategy for University of Hull MBA Program",
      "keywords": ["homepage", "mba", "university", "higher education", "web content", "seo", "conversion"],
      "primary_citation": {
        "source": "University of Hull Homepage Analysis",
        "url": "https://www.hull.ac.uk",
        "title": "Homepage Content Strategy",
        "snippet": "Analysis of Homepage content needs for University of Hull",
        "confidence": 0.9,
        "type": "platform_analysis",
        "domain": "website"
      },
      "secondary_citation": {
        "source": "Website Best Practices",
        "url": "https://websitebest-practices.com",
        "title": "Homepage Content Guidelines",
        "snippet": "Industry best practices for Homepage content in MBA programs",
        "confidence": 0.85,
        "type": "industry_guidelines",
        "domain": "website"
      },
      "impact_score": 85.0,
      "estimated_effort": "2-3 weeks"
    },
    {
      "content_type": "Digital Content - Video Content",
      "piece_type": "video",
      "title": "Video Content Strategy for University of Hull MBA Program",
      "keywords": ["video content", "mba", "university", "higher education"],
      "primary_citation": {
        "source": "University of Hull Video Content Analysis",
        "url": "https://www.hull.ac.uk",
        "title": "Video Content Strategy",
        "snippet": "Analysis of Video Content needs for University of Hull",
        "confidence": 0.9,
        "type": "platform_analysis",
        "domain": "digital_content"
      },
      "secondary_citation": {
        "source": "Digital Content Best Practices",
        "url": "https://digitalcontentbest-practices.com",
        "title": "Video Content Guidelines",
        "snippet": "Industry best practices for Video Content in MBA programs",
        "confidence": 0.85,
        "type": "industry_guidelines",
        "domain": "digital_content"
      },
      "impact_score": 85.0,
      "estimated_effort": "3-4 weeks"
    }
  ],
  "timestamp": "2025-01-27T12:00:00",
  "model_meta": {
    "model_used": "gpt-4o-mini",
    "search_engines": ["bing", "llm_web"],
    "data_freshness": "live"
  }
};
